import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { ENVIRONMENTS } from '../../types/environments';
import React from 'react';
var isInitialized = false;
var isSkipped = false;
var BugsnagService = /** @class */ (function () {
    function BugsnagService() {
    }
    BugsnagService.init = function (apiKey, releaseVersion, environment) {
        if (isSkipped) {
            return;
        }
        Bugsnag.start({
            apiKey: apiKey,
            plugins: [new BugsnagPluginReact()],
            releaseStage: environment,
            enabledReleaseStages: [ENVIRONMENTS.STAGE, ENVIRONMENTS.PRODUCTION],
            collectUserIp: false,
            appVersion: releaseVersion,
        });
        isInitialized = true;
    };
    /**
     * should be used to ignore calls of any methods of this service
     * in case if usage of BugsNag is disabled
     */
    BugsnagService.skipFlow = function () {
        isSkipped = true;
    };
    BugsnagService.addFeatureFlag = function (featureName, variant) {
        if (isSkipped) {
            return;
        }
        if (!isInitialized) {
            console.warn('BugsnagService: "addFeatureFlag" method was called before initialization');
            return;
        }
        Bugsnag.addFeatureFlag(featureName, variant);
    };
    /**
     * should be used to keep components structure if BugsNag is down or skipped
     */
    BugsnagService.getErrorBoundaryDummyComponent = function () {
        // eslint-disable-next-line react/prop-types
        var DummyErrorBoundary = function (_a) {
            var children = _a.children;
            return React.createElement(React.Fragment, null, children);
        };
        return DummyErrorBoundary;
    };
    BugsnagService.getErrorBoundaryComponent = function () {
        if (isSkipped) {
            return BugsnagService.getErrorBoundaryDummyComponent();
        }
        var bugsnagPlugin = Bugsnag.getPlugin('react');
        if (!bugsnagPlugin) {
            return BugsnagService.getErrorBoundaryDummyComponent();
        }
        return bugsnagPlugin.createErrorBoundary(React);
    };
    BugsnagService.emitVirtualNavigationEvent = function (msg) {
        if (isSkipped) {
            return;
        }
        if (!isInitialized) {
            console.warn('BugsnagService: "emitVirtualNavigationEvent" method was called before initialization');
            return;
        }
        if (typeof Bugsnag.resetEventCount === 'function') {
            // @note: is used for resetting of events, since there are no factual pushes
            // to History on virtual navigation events
            // https://docs.bugsnag.com/platforms/javascript/configuration-options/#maxevents
            Bugsnag.resetEventCount();
        }
        Bugsnag.leaveBreadcrumb(msg);
    };
    BugsnagService.emitHandledError = function (errMsg) {
        console.warn('BugsnagService: goes to handle error', errMsg);
        if (isSkipped) {
            return;
        }
        if (!isInitialized) {
            console.warn('BugsnagService: "emitHandledError" method was called before initialization');
            return;
        }
        Bugsnag.notify(new Error(errMsg));
    };
    return BugsnagService;
}());
export { BugsnagService };
